import {
  CreateLakeFsEntity,
  LakeFsEntity,
  LakeFsParams,
} from '@/pages/privatePages/lakefs/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class LakeFsServiceClass extends BaseService<
  'lakefs',
  LakeFsEntity,
  CreateLakeFsEntity
> {
  constructor() {
    super('lakefs');
  }

  uploadFile(payload: FormData): Promise<any> {
    return APIService.post('lake-fs', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getFiles(params: LakeFsParams) {
    return APIService.get('lake-fs', {
      params,
    });
  }
}

export const lakefsService = new LakeFsServiceClass();
